import { Injectable } from '@angular/core';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { IRegistrationState } from './state';
import { RegistrationApiService } from './api.service';
import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegistrationAsync {

  constructor(private readonly lux: Lux<{ registration: IRegistrationState }>, private readonly registrationApiService: RegistrationApiService) {
  }

  getValidationToken(req): Observable<any> {
    return of(req).pipe(
      first(),
      tap(() => this.lux.set(state => state.registration, { isFetching: true })),
      mergeMap(request => this.registrationApiService.getValidationToken(request)),
      tap(() => this.lux.set(state => state.registration, { isFetching: false })),
      catchError((err: HttpErrorResponse) => {
        this.lux.set(x => x.registration, { isFetching: false });
        return of(err.error.apiErrorList.map(item => item.errorMessage).join('\n'));
      })
    );
  }

  getAdministrators(req): Observable<any> {
    return of(req).pipe(
      first(),
      tap(() => this.lux.set(state => state.registration, { isFetching: true })),
      mergeMap(request => this.registrationApiService.getAdministrators(request)),
      tap(() => this.lux.set(state => state.registration, { isFetching: false })),
      catchError((err: HttpErrorResponse) => {
        this.lux.set(x => x.registration, { isFetching: false });
        return of(err.error.apiErrorList.map(item => item.errorMessage).join('\n'));
      })
    );
  }
}
